/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import { isWeb } from '../../../modules/checkDeployEnv';
import PageHeader from '../../atoms/PageHeader';
import OAuthLoginButtons from '../../components/OAuthLoginButtons';
import AccountPageFooter from '../../components/AccountPageFooter';
import Validation from '../../containers/Validation';

class Login extends Component {
  handleSubmit = form => {
    Meteor.loginWithPassword(form.emailAddress.value, form.password.value, error => {
      if (error) {
        handleErrorInClient(error);
      } else {
        Bert.alert('Welcome back!', 'success');
      }
    });
  };

  render() {
    const validationProps = {
      rules: {
        emailAddress: {
          required: true,
          email: true
        },
        password: {
          required: true
        }
      },
      messages: {
        emailAddress: {
          required: 'Need an email address here.',
          email: 'Is this email address correct?'
        },
        password: {
          required: 'Need a password here.'
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };
    const { deployEnv } = this.props;
    return (
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6}>
          <PageHeader>
            <h4>Log In</h4>
          </PageHeader>
          {isWeb(deployEnv) && (
            <Row>
              <Col xs={12}>
                <OAuthLoginButtons
                  services={['facebook', 'esri', 'google']}
                  emailMessage={{
                    offset: 97,
                    text: 'Log In with an Email Address'
                  }}
                />
              </Col>
            </Row>
          )}
          <Validation {...validationProps}>
            <Form onSubmit={event => event.preventDefault()}>
              <Form.Group>
                <Form.Label>Email Address</Form.Label>
                <Form.Control type="email" name="emailAddress" placeholder="Enter email" />
              </Form.Group>
              <Form.Group>
                <Form.Label column className="clearfix px-0">
                  <span className="float-left">Password</span>
                  <Link className="float-right" to="/recover-password">
                    Forgot password?
                  </Link>
                </Form.Label>
                <Form.Control type="password" name="password" placeholder="Password" />
              </Form.Group>
              <Button type="submit" variant="success" block>
                Login
              </Button>
              <AccountPageFooter>
                <p>
                  Don't have an account? <Link to="/signup">Sign Up</Link>.
                </p>
              </AccountPageFooter>
            </Form>
          </Validation>
        </Col>
      </Row>
    );
  }
}

Login.propTypes = {
  deployEnv: PropTypes.string.isRequired
};

export default Login;
